let locales = {
    configStatusLeads_status: 'Estado',
    configStatusLeads_description: 'Descripción',
};
export default locales;